
import { Link } from 'react-router-dom';

export default function DealershipProcess() {
  const steps = [
    {
      number: '1',
      title: 'Application',
      description: 'Submit your dealership application with business background and market information.',
      details: ['Complete application form', 'Business plan review', 'Market analysis', 'Financial qualification'],
      timeline: '1-2 weeks'
    },
    {
      number: '2',
      title: 'Approval & Agreement',
      description: 'Review and sign dealership agreement after approval and territory assignment.',
      details: ['Application review', 'Territory assignment', 'Contract negotiation', 'Legal documentation'],
      timeline: '2-3 weeks'
    },
    {
      number: '3',
      title: 'Investment & Setup',
      description: 'Complete investment payment and begin setup of your dealership operations.',
      details: ['Investment payment', 'Product selection', 'System setup', 'Marketing materials'],
      timeline: '1-2 weeks'
    },
    {
      number: '4',
      title: 'Training Program',
      description: 'Comprehensive training on products, sales, installation, and business operations.',
      details: ['Product training', 'Sales techniques', 'Installation methods', 'Business operations'],
      timeline: '2-4 weeks'
    },
    {
      number: '5',
      title: 'Launch Support',
      description: 'Grand opening support with marketing campaigns and on-site assistance.',
      details: ['Marketing launch', 'Grand opening event', 'Initial sales support', 'Customer acquisition'],
      timeline: '2-3 weeks'
    },
    {
      number: '6',
      title: 'Ongoing Success',
      description: 'Continuous support, new product updates, and business growth assistance.',
      details: ['Regular check-ins', 'New product releases', 'Marketing updates', 'Performance optimization'],
      timeline: 'Ongoing'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Dealership Process</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our streamlined process gets you from application to successful dealership launch in 8-12 weeks.
          </p>
        </div>

        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 p-8">
                <div className="lg:col-span-1">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mr-4">
                      <span className="text-white font-bold text-lg">{step.number}</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                      <div className="text-sm text-emerald-600 font-medium">{step.timeline}</div>
                    </div>
                  </div>
                </div>
                
                <div className="lg:col-span-2">
                  <p className="text-gray-600 mb-4">{step.description}</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {step.details.map((detail, detailIndex) => (
                      <div key={detailIndex} className="flex items-center">
                        <i className="ri-check-line text-emerald-600 mr-2"></i>
                        <span className="text-sm text-gray-600">{detail}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="lg:col-span-1 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <i className="ri-time-line text-emerald-600 text-2xl"></i>
                    </div>
                    <div className="text-sm font-medium text-gray-900">Timeline</div>
                    <div className="text-sm text-gray-600">{step.timeline}</div>
                  </div>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flex justify-center pb-4">
                  <i className="ri-arrow-down-line text-emerald-600 text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="text-center">
            <Link
              to="/dealership/starter"
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Application Process
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
